"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BYTES_IN_MEGABYTE = void 0;
var BYTES_IN_MEGABYTE = 1000000;
exports.BYTES_IN_MEGABYTE = BYTES_IN_MEGABYTE;